import React from 'react';

import {DigestAnalysis} from 'analyses/Analyses';
import Enzymes from 'molbio/enzymes/backbone/Enzymes';
import DigestLibraryItem from 'toolbar/restriction-panel/DigestLibraryItem';

export interface DigestLibraryProps {
  /** A list of digests to display. */
  digests: Array<DigestAnalysis>;
  /** Whether to disable deleting digests */
  disableDelete: boolean;
  /** The list of all enzymes on the sequence being digested */
  enzymes: Enzymes;
  /** A function to be called when a digest is clicked */
  onClickItem: (analysis: DigestAnalysis) => void;
  /** A function to be called when a digest is deleted */
  onDeleteItem: (analysis: DigestAnalysis) => void;
}

export default function DigestLibrary({
  digests,
  disableDelete,
  enzymes,
  onClickItem,
  onDeleteItem,
}: DigestLibraryProps): JSX.Element {
  if (digests.length === 0) {
    return (
      <tr>
        <td colSpan={2}>You don't have any saved digests yet.</td>
      </tr>
    );
  } else {
    return (
      <>
        {digests.map((digest) => {
          const enzymeNames = (digest.get('enzymes') ?? []).map((enzymeId: number) =>
            enzymes.get(enzymeId).get('name')
          );
          return (
            <DigestLibraryItem
              disableDelete={disableDelete}
              enzymeNamesDisplay={enzymeNames.join(', ')}
              key={digest.id}
              name={digest.get('name') ?? ''}
              onClick={() => {
                onClickItem(digest);
              }}
              onClickDelete={() => {
                onDeleteItem(digest);
              }}
            />
          );
        })}
      </>
    );
  }
}
